module.exports = __webpack_public_path__ + "static/media/bg.49a91697.png";